import PropTypes from "prop-types"
import React, { useContext } from "react"

import {
  generateGeoPathData,
  geoAreaLocationProviderDirectoryPath,
  geoBreakdownDirectoryURL,
} from "../../../../utils/paths"
import SmartLink from "../../../layout/SmartLink/SmartLink"
import CareTypeContext from "../../../../contexts/care_type"
import { InlineText } from "../../../Typography/Typography"

const geoLinkClickEvent = (targetPath, clickEventName) => ({
  name: `SEO - Filtered Directory - ${clickEventName} Geo Clicked`,
  properties: {
    "Current URL": geoBreakdownDirectoryURL(),
    "Target Path": targetPath,
  },
})

const GeoBreakdownHeadingLink = ({
  geographicScale,
  locationName,
  districtType,
  copyHandler,
  careHomeCount,
  homeCareCount,
  dementiaCareHomeCount,
  geoLevel,
  careServiceType,
}) => {
  const careTypeContext = useContext(CareTypeContext)
  const careType = careTypeContext ? careTypeContext.careType : null

  const pageType = careServiceType || careType

  const providerCountByPageType = {
    care_home: careHomeCount,
    home_care: homeCareCount,
    dementia: dementiaCareHomeCount,
  }

  const providerCount =
    providerCountByPageType[pageType] || careHomeCount + homeCareCount

  const copyText = providerCount
    ? `${locationName} (${providerCount})`
    : `${locationName}`

  const clickEventName = geoLevel === "geosUp" ? "Parent" : "Nearby"

  return (
    <SmartLink
      to={geoAreaLocationProviderDirectoryPath(
        generateGeoPathData(
          geographicScale,
          locationName,
          careType,
          districtType,
        ),
        careServiceType,
      )}
      clickEvent={geoLinkClickEvent(
        geoAreaLocationProviderDirectoryPath(
          generateGeoPathData(
            geographicScale,
            locationName,
            careType,
            districtType,
          ),
        ),
        clickEventName,
      )}
    >
      <InlineText brand useParentSize useParentFontWeight>
        {" "}
        {copyHandler(copyText)}
      </InlineText>
    </SmartLink>
  )
}

GeoBreakdownHeadingLink.propTypes = {
  geographicScale: PropTypes.string.isRequired,
  locationName: PropTypes.string.isRequired,
  districtType: PropTypes.string,
  copyHandler: PropTypes.func, // Called with the locationName to provide copy text
  careHomeCount: PropTypes.number,
  homeCareCount: PropTypes.number,
  dementiaCareHomeCount: PropTypes.number,
  geoLevel: PropTypes.string,
  careServiceType: PropTypes.oneOf(["dementia"]),
}

GeoBreakdownHeadingLink.defaultProps = {
  districtType: null,
  copyHandler: (x) => x,
  careHomeCount: null,
  homeCareCount: null,
  dementiaCareHomeCount: null,
  geoLevel: undefined,
  careServiceType: undefined,
}

export default GeoBreakdownHeadingLink
